import { ENDPOINT_URLS } from '~/global/toggle-api';
import { APIFetch } from '~/shared/services/api-fetch/APIFetch';
import { HttpMethods } from '~/shared/services/api-fetch/constants';
import { TwoFactorMethod } from '~/shared/services/auth/authService';

// API doc reference: https://www.notion.so/toggle/Backend-API-documentation-c67fc9d833484a878e401d4a55030e70#5d1e85772a5b464f93ce9aa00143c19b

export interface TwofaStatus {
  enabled: TwoFactorMethod[];
}

export type TwofaEnableTotp =
  | {
      enabled: false;
      key?: string;
      code?: string;
    }
  | {
      enabled: true;
      key: string;
      code: string;
    };

export interface TwofaTotpCode {
  key: string;
  qr_code: string;
}

export interface BackupCodesType {
  available: string[];
  used: string[];
}

export const postSendEmail = (userId: string) => {
  return APIFetch(ENDPOINT_URLS.TWOFA_SEND_EMAIL, {
    method: HttpMethods.Post,
    body: JSON.stringify({ user_id: userId }),
  });
};

export const get2faStatus = () => {
  return APIFetch<TwofaStatus>(ENDPOINT_URLS.TWOFA_GET_STATUS);
};

export const postEnableEmail = (enabled: boolean) => {
  return APIFetch(ENDPOINT_URLS.TWOFA_ENABLE_EMAIL, {
    method: HttpMethods.Post,
    body: JSON.stringify({ enabled }),
  });
};

export const postEnableTotp = (request: TwofaEnableTotp) => {
  return APIFetch(ENDPOINT_URLS.TWOFA_ENABLE_TOTP, {
    method: HttpMethods.Post,
    body: JSON.stringify(request),
  });
};

export const getTotpKey = () => {
  return APIFetch<TwofaTotpCode>(ENDPOINT_URLS.TWOFA_TOTP_CODE);
};

export const getBackupCodes = () => {
  return APIFetch<BackupCodesType>(ENDPOINT_URLS.TWOFA_BACKUP_CODES);
};
